import { computed } from 'vue'

import type { ComputedRef } from 'vue'

import { useListsStore } from '@shared/model'

import { useTutorKanbanStore } from './store'

interface MainInfoCategoryReturn {
  refValue: ComputedRef<string>
}

export const useMainInfoCategory = (): MainInfoCategoryReturn => {
  const tutorKanbanStore = useTutorKanbanStore()
  const listsStore = useListsStore()

  const refValue = computed<string>(() => {
    const categories = tutorKanbanStore.getTutor?.categories as string[] | null
    const categoryList = listsStore.getTutor?.category ?? {}

    if (!categories?.length) return ''

    return categories
      .map((id: string) => categoryList[id] ?? id)
      .join(', ')
  })

  return {
    refValue,
  }
}
